import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import { PrimaryButton } from "./ui/PrimaryButton";
import { EmailInput } from "./ui/EmailInput";
import { TextInput } from "./ui/TextInput";
import { Checkbox as CheckboxCustom } from "./ui/Checkbox";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import {
  Text,
  Anchor,
  Paper,
  Title,
  Group,
  Grid,
  Center,
  Space,
} from "@mantine/core";
import { PasswordInput } from "./ui/PasswordInput";
import { Logo } from "./Logo";
import { domain1, domain2, goLoginClickHandler } from "../utils/common";

export const Register = ({ isDev = false }) => {
  const isMobile = !useMediaQuery("(min-width: 750px)");
  const langs = isDev ? {} : window.getLangs();
  const [currentMailPath, setCurrentMailPath] = useState(domain1);

  const form = useForm({
    initialValues: {
      login: "",
      termsOfService: true,
      password: "",
      repeatPassword: "",
      firstname: "",
      surname: "",
      regRecoverEmail: "",
    },

    validate: {
      password: (value) => (value.length > 5 ? null : "Short password"),
    },
  });

  const handleFormAction = () => {};

  useEffect(() => {
    window.console.log(333, langs);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        background: "#e8e8e8",
        minHeight: "100vh",
        backgroundImage: isMobile ? "" : "url(./background.jpg)",
        backgroundSize: "cover",
      }}
    >
      <form
        onSubmit={form.onSubmit(handleFormAction)}
        autocomplete="off"
        style={{
          margin: "50px auto 0",
          width: isMobile ? "100%" : "auto",
        }}
      >
        <Paper
          radius={isMobile ? 0 : 24}
          p={"12px 35px 30px"}
          miw={isMobile ? "100%" : "560px"}
          style={{
            background: "#e8e8e8",
            boxShadow: isMobile ? "" : "0 0 30px 0 rgba(0,0,0,0.3)",
          }}
        >
          <Logo />
          <Grid>
            <Center>
              <Title
                className="no_select"
                style={{ fontWeight: 600, cursor: "default" }}
                order={1}
                ml={5}
                align="left"
                mt="md"
                mb={20}
              >
                {langs["go_register_button"] ?? "Signup"}
              </Title>
            </Center>
            <Center ml={30}>
              <Title
                className="no_select"
                style={{ fontWeight: 600, opacity: 0.5, cursor: "pointer" }}
                order={3}
                align="left"
                mt="xl"
                mb={20}
                onClick={goLoginClickHandler}
              >
                {langs["login_title"] ?? "Login"}
              </Title>
            </Center>
          </Grid>

          <Group position="apart" mb={0}>
            <Text component="label" sx={{ fontSize: "15px" }} weight={700}>
              {langs["firstname"] ?? "Firstname"}
            </Text>
          </Group>
          <TextInput
            form={form}
            formFieldName="firstname"
            id="reg_firstname"
            name="firstname"
            type="text"
            placeholder={langs["firstname"] ?? "Firstname"}
          />

          <Group position="apart" mt={16}>
            <Text component="label" sx={{ fontSize: "15px" }} weight={700}>
              {langs["surname"] ?? "Surname"}
            </Text>
          </Group>
          <TextInput
            form={form}
            formFieldName="surname"
            id="reg_surname"
            name="surname"
            type="text"
            placeholder={langs["surname"] ?? "Surname"}
          />

          <Group position="apart" mt={16}>
            <Text component="label" sx={{ fontSize: "15px" }} weight={700}>
              {langs["login_name"] ?? "Reg login name"}
            </Text>
            <Anchor
              href="#"
              onClick={() => {
                setCurrentMailPath(
                  currentMailPath !== domain2 ? domain2 : domain1
                );
              }}
              sx={() => ({
                color: "#2275e2",
                fontWeight: 700,
                fontSize: "15px",
              })}
            >
              {currentMailPath !== domain2 ? domain2 : domain1}
            </Anchor>
          </Group>
          <EmailInput
            id="reg_login_name"
            form={form}
            formFieldName="login"
            rightText={currentMailPath}
            placeholder={langs["login_name"] ?? "Your login"}
          />
          <div id="basic-addon2" style={{ display: "none" }}>
            {currentMailPath}
          </div>
          <Group position="apart" mt={16} mb={0}>
            <Text
              component="label"
              htmlFor="reg_new_password"
              sx={{ fontSize: "15px" }}
              weight={700}
            >
              {langs["password"] ?? "Password"}
            </Text>
          </Group>
          <PasswordInput
            id={"reg_new_password"}
            form={form}
            formFieldName="password"
            placeholder={langs["password"] ?? "Password"}
          />
          <div id="register_password_small"></div>

          <Group position="apart" mt={16} mb={0}>
            <Text
              component="label"
              htmlFor="reg_repeat_password"
              sx={{ fontSize: "15px" }}
              weight={700}
            >
              {langs["recover_repeat_password"] ?? "Repeat password"}
            </Text>
          </Group>
          <PasswordInput
            required
            id={"reg_repeat_password"}
            form={form}
            formFieldName="repeatPassword"
            placeholder={langs["recover_repeat_password"] ?? "Repeat password"}
          />

          <Group position="apart" mt={16} mb={0}>
            <Text
              component="label"
              htmlFor="reg_recover_email"
              sx={{ fontSize: "15px" }}
              weight={700}
            >
              {langs["recover_email"] ?? "Recover e-mail"}
            </Text>
          </Group>
          <TextInput
            required
            form={form}
            formFieldName="regRecoverEmail"
            id="reg_recover_email"
            name="reg_recover_email"
            type="text"
            placeholder={langs["recover_email"] ?? "Recover e-mail"}
          />

          <Space mt="md" />
          <div id="error_reg" />
          <div id="success_reg" />
          <input
            type="hidden"
            name="g-recaptcha-response"
            id="g-recaptcha-response"
          />
          <input type="hidden" name="action" value="validate_captcha" />
          <Grid mt={24}>
            <Grid.Col span={isMobile ? 12 : 6} mb={isMobile ? 12 : 0}>
              <PrimaryButton
                fullWidth
                id="register_button"
                onClick={() => {
                  window.sendRegisterForm(langs);
                  window.recaptchaUpdateToken();
                  return false;
                }}
                disabled={
                  !form.values.termsOfService ||
                  !form.values.login.length ||
                  !form.values.password.length ||
                  !form.values.firstname.length ||
                  !form.values.surname.length ||
                  !form.values.regRecoverEmail.length ||
                  form.values.password !== form.values.repeatPassword
                }
              >
                {langs["register_button"] ?? "Register"}
              </PrimaryButton>
            </Grid.Col>
            <Grid.Col span={isMobile ? 12 : 6}>
              <Button onClick={goLoginClickHandler} fullWidth>
                {langs["login_title"] ?? "Back to login"}
              </Button>
            </Grid.Col>
          </Grid>
          <Space mt="md" />
          <CheckboxCustom
            id="register_agree_checkbox"
            checked={form.values.termsOfService}
            onChange={() =>
              form.setFieldValue("termsOfService", !form.values.termsOfService)
            }
            label={<div>{langs["register_warning_2"] ?? "I agree"} </div>}
          />
          <Space mt="sm" />
          <div>
            <Anchor
              href="/user-agree"
              target="_blank"
              sx={{
                color: "var(--mantine-color-gray-9)",
                fontWeight: 800,
                lineHeight: "32px",
                textShadow: "0 0 20px white",
              }}
            >
              {langs["register_warning_3"] ?? "User Agreement"}
            </Anchor>
          </div>
        </Paper>
        <Space mt={50} w="100%" />
      </form>
    </div>
  );
};
